import React, { useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

const Home = () => {
  //   try {
  //     const response = await axios.get(`${API}/`);
  //     console.log(response.data.message);
  //   } catch (e) {
  //     console.error(e, `errored out requesting / api`);
  //   }
  // };

  //   helloWorldApi();
  // }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Hero Section */}
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          Добро пожаловать в Тестирования профиля личности
        </h1>
        <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
          Откройте для себя ваши природные интеллекты и склонности. 
          Наши тесты помогут вам лучше понять себя и выбрать подходящую деятельность.
        </p>
        <Link
          to="/tests"
          className="bg-purple-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors"
        >
          Начать тестирование
        </Link>
      </div>

      {/* Features Section */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            Тест по природным интеллектам
          </h3>
          <p className="text-gray-600 mb-4">
            81 вопрос для определения ваших врожденных склонностей и способностей. 
            Узнайте, к какому виду деятельности вас тянет больше всего.
          </p>
          <Link
            to="/tests/natural-intelligence"
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            Пройти тест →
          </Link>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            Анкета по типам интеллекта
          </h3>
          <p className="text-gray-600 mb-4">
            90 вопросов на основе теории множественных интеллектов Г. Гарднера. 
            Определите ваши ведущие типы интеллекта.
          </p>
          <Link
            to="/tests/intelligence-types"
            className="text-green-600 hover:text-green-800 font-medium"
          >
            Пройти анкету →
          </Link>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            Анкета по Белбину
          </h3>
          <p className="text-gray-600 mb-4">
            Определите вашу предпочтительную роль в команде. 
            8 блоков вопросов с распределением баллов.
          </p>
          <Link
            to="/tests/belbin"
            className="text-purple-600 hover:text-purple-800 font-medium"
          >
            Пройти тест →
          </Link>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            Тест на определение ОРС
          </h3>
          <p className="text-gray-600 mb-4">
            Выявите вашу ведущую репрезентативную систему: 
            визуальная, аудиальная, кинестетическая или дигитальная.
            <br /> 15 вопросов + 4 дополнительных.
          </p>
          <Link
            to="/tests/ors"
            className="text-red-600 hover:text-red-800 font-medium"
          >
            Пройти тест →
          </Link>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md lg:col-span-2">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            Тест на подтип личности (мотивация)
          </h3>
          <p className="text-gray-600 mb-4">
            Определите ваш доминирующий инстинктивный подтип: самосохранение, 
            сексуальный или социальный. 30 вопросов о ваших мотивациях и предпочтениях.
          </p>
          <Link
            to="/tests/subtype"
            className="text-orange-600 hover:text-orange-800 font-medium"
          >
            Пройти тест →
          </Link>
        </div>
      </div>

      {/* About Section */}
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          О тестировании
        </h2>
        <p className="text-gray-600 mb-4">
          Каждый человек рождается с врожденными склонностями, которые усиливаются 
          нашим окружением — особенно на ранних стадиях жизни. Эти черты влияют на то, 
          как мы действуем и к какому виду деятельности нас тянет.
        </p>
        <p className="text-gray-600">
          Наши тесты помогут вам выявить ваши природные склонности и определить 
          оптимальные направления для личного и профессионального развития.
        </p>
      </div>
    </div>
  );
};

export default Home;